<template>
  <sweet-modal ref="success" icon="success" width="500px" @open="countCloseModal('success', 15)">
    <span class="confirmation-text">{{  text }}</span>
    <button slot="button" class="ba-btn ba-md ba-light inline-button" v-on:click="$refs.success.close()">
      {{ $t('ct-not-now') }} {{ this.timeToClose }}
    </button>
    <button slot="button" class="ba-btn ba-md ba-green inline-button focus" @click.prevent="publishWebsite()" :disabled="!showRepublish">{{ $t('ct-thats-fine') }}
    </button>
  </sweet-modal>
</template>

<script>
import {SweetModal, SweetModalTab} from "sweet-modal-vue";
import axios from "axios";
import {updateVersion} from "../../js/services/editor/publish";

export default {
  name: "ModalSavedAndPublish",
  components: {
    SweetModal, SweetModalTab
  },
  props: ['id_website', 'showRepublish', 'message'],
  data() {
    return {
      timeToClose: 0,
    };
  },
  computed: {
    hasPublishListener() {
      return this.$listeners && this.$listeners.publish
    },
    text() {
      return this.message || this.$t('ct-saved') + ' ' + this.$t('ct-do-want-publish-website');
    }
  },
  methods: {
    open() {
      this.$refs.success.open()
    },
    close() {
      this.$refs.success.close()
    },
    countCloseModal: function (ref, seconds) {
      this.timeToClose = seconds;

      let interval = setInterval(() => {
        this.timeToClose--;
      }, 1000);

      setTimeout(() => {
        this.$refs[ref].close();
        clearInterval(interval);
      }, seconds * 1000);
    },

    publishWebsite() {
      if (this.hasPublishListener) {
        this.$emit('publish');
        return;
      }

      if (window.location.hostname === 'localhost') {
        axios.get('http://publication.localhost/cheetah/local-publish-aux').then((res) => {
          console.log(res.data);
        });
      }

      updateVersion(this.id_website)
        .then(() => {
          this.$loading.show();

          setTimeout(() => {
            this.$loading.hide();
            this.$refs.success.close();
          }, 200);
        })
        .catch(error => {
          this.$refs.success.close();

          if (error.response.status === 401) {
            const message = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'ct-plan-limited'
            this.$snotify.error(this.$t(message));
          } else {
            this.$snotify.error('Something happened when trying to publish your site, check the settings');
          }
        }); 
    },
  }
};
</script>

<style lang="scss">
.confirmation-text {
  color: #54779E;
  font-size: 16px;
  font-weight: 600;
  display: block;
  text-align: center;
  font-family: 'montserrat';
}
.inline-button {
  display: inline-flex !important;
  margin-left: 10px;
  padding: 9.6px 19.2px;
  font-size: 12.8px;
  text-transform: uppercase;
  border: none;
  border-radius: 10px;
  outline: none;
  justify-content: center;
  align-items: center;
  gap: 9.6px;
  font-weight: 600;
  transition: all .4s;
  font-family: 'montserrat';
  &.ba-green {
    color: #fff;
    background-color: #1ad9a9;
  }
  &.ba-light {
    color: #486688;
    background-color: #f6f8fb;
  }
}
.sweet-modal-icon.sweet-modal-success .sweet-modal-placeholder {
  border-color: #1ad9a9;
}
.sweet-modal-icon.sweet-modal-success .sweet-modal-line {
  background-color: #1ad9a9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ModalSavedAndPublish.vue